import {
  WhmBox,
  WhmCard,
  WhmCardContent,
  WhmDivider,
  WhmSkeleton,
  WhmStack,
} from "@securitize/reactjs-whm";

type EntityOnboardingCardSkeletonProps = {
  compressed?: boolean;
};

export default function EntityOnboardingCardSkeleton({
  compressed = false,
}: EntityOnboardingCardSkeletonProps) {
  return (
    <WhmCard variant="outlined">
      <WhmCardContent
        sx={{
          "&:last-child": {
            paddingBottom: "16px",
          },
        }}
      >
        <WhmStack
          id="portfolio-value-skeleton"
          data-test-id="potrfolio-value-skeleton"
        >
          <WhmBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              paddingBottom: "60px",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <WhmBox>
              <WhmSkeleton
                variant="rounded"
                sx={{ marginBottom: "4px" }}
                width={200}
                height={32}
              />
              <WhmSkeleton variant="rounded" width={288} height={24} />
            </WhmBox>
            <WhmSkeleton variant="rounded" width={216} height={42} />
          </WhmBox>

          <WhmBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <WhmBox>
              <WhmSkeleton
                variant="rounded"
                sx={{ marginBottom: "4px" }}
                width={200}
                height={28}
              />
              {!compressed && (
                <WhmSkeleton variant="rounded" width={288} height={20} />
              )}
            </WhmBox>
            {!compressed && (
              <WhmSkeleton variant="rounded" width={105} height={42} />
            )}
          </WhmBox>

          <WhmDivider
            sx={{
              marginTop: compressed ? "16px" : "24px",
              marginBottom: "24px",
            }}
          />

          <WhmBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <WhmBox>
              <WhmSkeleton
                variant="rounded"
                sx={{ marginBottom: "4px" }}
                width={200}
                height={28}
              />

              {!compressed && (
                <WhmSkeleton variant="rounded" width={288} height={20} />
              )}
            </WhmBox>
            {!compressed && (
              <WhmSkeleton variant="rounded" width={105} height={42} />
            )}
          </WhmBox>

          <WhmDivider
            sx={{
              marginTop: compressed ? "16px" : "24px",
              marginBottom: "24px",
            }}
          />

          <WhmBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <WhmBox>
              <WhmSkeleton
                variant="rounded"
                sx={{ marginBottom: "4px" }}
                width={200}
                height={28}
              />
              {!compressed && (
                <WhmSkeleton variant="rounded" width={288} height={20} />
              )}
            </WhmBox>
            {!compressed && (
              <WhmSkeleton variant="rounded" width={105} height={42} />
            )}
          </WhmBox>
        </WhmStack>
      </WhmCardContent>
    </WhmCard>
  );
}
